/**
 * V2 마이그레이션 테스트 라우트
 * 개발 환경에서만 접근 가능
 */

import type { RouteRecordRaw } from 'vue-router'

export const v2TestRoutes: RouteRecordRaw[] = [
  {
    path: '/v2-test',
    name: 'v2-test',
    component: () => import('@/views/v2-test/V2TestDashboard.vue'),
    meta: {
      requiresAuth: false,
      title: 'V2 Migration Test',
    },
    children: [
      {
        path: 'login',
        name: 'v2-test-login',
        component: () => import('@/components/examples/LoginV2.vue'),
        meta: {
          title: 'V2 Login Test',
        },
      },
      {
        path: 'accounts',
        name: 'v2-test-accounts',
        component: () => import('@/components/examples/AccountListV2.vue'),
        meta: {
          title: 'V2 Accounts Test',
        },
      },
      {
        path: 'create-account',
        name: 'v2-test-create-account',
        component: () => import('@/components/examples/CreateAccountV2.vue'),
        meta: {
          title: 'V2 Create Account Test',
        },
      },
      {
        path: 'api-test',
        name: 'v2-test-api',
        component: () => import('@/views/v2-test/V2ApiTest.vue'),
        meta: {
          title: 'V2 API Test',
        },
      },
      {
        path: 'nfts',
        name: 'v2-test-nfts',
        component: () => import('@/components/examples/NFTListV2.vue'),
        meta: {
          title: 'V2 NFTs Test',
        },
      },
      {
        path: 'transactions',
        name: 'v2-test-transactions',
        component: () => import('@/views/v2-test/TransactionTest.vue'),
        meta: {
          title: 'V2 Transactions Test',
        },
      },
      {
        path: 'wallet',
        name: 'v2-test-wallet',
        component: () => import('@/views/v2-test/WalletTest.vue'),
        meta: {
          title: 'V2 Wallet Test',
        },
      },
      {
        path: 'nft',
        name: 'v2-test-nft',
        component: () => import('@/views/v2-test/NFTTest.vue'),
        meta: {
          title: 'V2 NFT Test',
        },
      },
      {
        path: 'account-token',
        name: 'v2-test-account-token',
        component: () => import('@/views/v2-test/AccountTokenTest.vue'),
        meta: {
          title: 'V2 Account Token Test',
        },
      },
      {
        path: 'user',
        name: 'v2-test-user',
        component: () => import('@/views/v2-test/UserTest.vue'),
        meta: {
          title: 'V2 User Management Test',
        },
      },
    ],
  },
]

// 개발 환경에서만 라우트 추가
export const addV2TestRoutes = () => {
  if (import.meta.env.DEV || import.meta.env.VITE_ENABLE_V2_TEST === 'true') {
    return v2TestRoutes
  }
  return []
}
